export const fetcher = (endpoint, opts = {}) => {
  // opts = { api, body, method, headers }

  const apiUrl = opts.api || '/api'
  const body = JSON.stringify(opts.body || undefined)
  const method = opts.method || 'GET'
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...opts.headers,
  }

  return fetch(`${apiUrl}${endpoint}`, {
    method: method || 'GET',
    body,
    headers,
  }).then(async (R) => {
    let response
    try {
      response = await R.json()
      // eslint-disable-next-line no-empty
    } catch (e) {}

    if (R.ok === false) {
      // Don't report 401s, 404s, etc. since that's the expected behavior
      // if (!doNotReportThese.includes(R?.status)) {
      //   reportError(
      //     new Error(`Failed to fetch ${method} ${apiUrl}${endpoint}`),
      //     {
      //       extra: {
      //         status: R.status,
      //         statusText: R.statusText,
      //         ok: R.ok,
      //         url: R.url,
      //         response,
      //       },
      //     }
      //   )
      // }

      throw response
    }

    return response
  })
}


